"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.H_HANDLER_ARROW = exports.V_HANDLER_ARROW = exports.HANDLER_ARROW = exports.H_NAV_HANDLER = exports.V_NAV_HANDLER = exports.NAV_HANDLER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var HANDLER_SIZE = "200px",
    NAV_HANDLER_AFTER_BEFORE = {
  before: {
    content: "\"\"",
    position: "absolute",
    top: 0,
    bottom: 0,
    background: _vars.COLOURS.grey.codGrey
  },
  after: {
    content: "\"\"",
    position: "absolute",
    background: _vars.COLOURS.grey.codGrey
  }
},
    NAV_HANDLER = {
  position: "absolute",
  cursor: "pointer",
  zIndex: 0,
  overflow: "hidden"
};
exports.NAV_HANDLER = NAV_HANDLER;
var V_NAV_HANDLER = (0, _cxs["default"])(_objectSpread({}, NAV_HANDLER, {
  height: "200px",
  width: "20px",
  top: "calc(50% - ".concat("200px", " / 2)"),
  left: "-20px",
  "&::before": _objectSpread({}, NAV_HANDLER_AFTER_BEFORE.before, {
    height: "50%",
    top: 0,
    width: "100%",
    borderTopLeftRadius: "5px",
    transform: "skewY(-45deg)",
    transformOrigin: "top right"
  }),
  "&::after ": _objectSpread({}, NAV_HANDLER_AFTER_BEFORE.after, {
    left: 0,
    right: 0,
    bottom: 0,
    height: "50%",
    borderBottomLeftRadius: "5px",
    transform: "skewY(-310deg)",
    transformOrigin: "bottom right"
  })
}));
exports.V_NAV_HANDLER = V_NAV_HANDLER;
var H_NAV_HANDLER = (0, _cxs["default"])(_objectSpread({}, NAV_HANDLER, {
  width: "200px",
  height: "20px",
  left: "calc(50% - ".concat("200px", " / 2)"),
  top: "-20px",
  "&::before": _objectSpread({}, NAV_HANDLER_AFTER_BEFORE.before, {
    right: 0,
    width: "50%",
    background: _vars.COLOURS.grey.codGrey,
    borderTopRightRadius: "5px",
    transform: "skewX(50deg)",
    transformOrigin: "bottom left"
  }),
  "&::after ": _objectSpread({}, NAV_HANDLER_AFTER_BEFORE.after, {
    top: 0,
    bottom: 0,
    left: 0,
    width: "50%",
    borderTopLeftRadius: "5px",
    transform: "skewX(310deg)",
    transformOrigin: "bottom left"
  })
}));
exports.H_NAV_HANDLER = H_NAV_HANDLER;
var HANDLER_ARROW = {
  position: "absolute",
  zIndex: 1,
  border: "4px solid transparent"
};
exports.HANDLER_ARROW = HANDLER_ARROW;
var V_HANDLER_ARROW = (0, _cxs["default"])(_objectSpread({}, HANDLER_ARROW, {
  top: "calc(50% - 7px)",
  left: "5px"
}));
exports.V_HANDLER_ARROW = V_HANDLER_ARROW;
var H_HANDLER_ARROW = (0, _cxs["default"])(_objectSpread({}, HANDLER_ARROW, {
  transform: "rotate(180deg)",
  top: "5px",
  left: "calc(50% - 7px)"
}));
exports.H_HANDLER_ARROW = H_HANDLER_ARROW;